import type { Article } from './types';

export const articles: Article[] = [
  {
    slug: 'jd-618-super-discount-2026',
    title: '京东618超级福利日：全场满300减50，叠加优惠券最高省800元',
    excerpt: '京东618年中大促全面启动，我们整理了最全的优惠攻略，包括满减规则、红包领取入口、限时秒杀时间表等核心信息。',
    content: `<p>一年一度的京东618年中大促已经正式拉开帷幕。作为国内最大的电商购物节之一，今年的618在优惠力度上再次升级，我们为读者整理了最全面的省钱攻略。</p>
<h4>一、核心优惠机制</h4>
<p>本次618活动主打"满300减50"的跨店满减，同时支持平台红包与店铺优惠券叠加使用。经过实际测算，合理搭配后最高可实现800元的综合优惠。</p>
<p>特别需要注意的是，部分品类（如3C数码、家电）支持额外的品类券，可以与跨店满减叠加。例如购买一台标价5999元的笔记本电脑，叠加跨店满减（-50×19=950）、品类券（-300）、店铺券（-200），最终到手价仅4549元。</p>
<h4>二、红包领取攻略</h4>
<p>京东官方每天发放三次红包雨，时间分别为10:00、14:00、20:00。根据往年经验，20:00场的红包金额通常最大，建议设置闹钟准时参与。</p>
<p>此外，邀请好友助力可获得额外膨胀红包，最高可膨胀至原金额的3倍。每个账号每天最多可邀请5位好友助力。</p>
<h4>三、热门品类推荐</h4>
<p>我们筛选了几个优惠力度最大的品类：</p>
<ul>
<li>手机通讯：iPhone 16系列直降800元起，华为Mate 70系列送原装耳机</li>
<li>家电：格力空调全场8折，海尔冰箱买大送小</li>
<li>美妆护肤：雅诗兰黛、兰蔻等国际大牌满499减100</li>
<li>运动户外：Nike、Adidas官方旗舰店低至5折</li>
</ul>
<h4>四、注意事项</h4>
<p>建议在活动正式开始前做好以下准备：提前将心仪商品加入购物车、领取所有可领取的优惠券、开通京东PLUS会员享受额外折扣。同时注意比价，部分商品可能存在先涨价后降价的情况，建议使用第三方比价工具确认历史价格。</p>`,
    category: 'discount',
    categoryName: '折扣优惠',
    imageSeq: 'art-jd618',
    date: '2026-06-15',
    readTime: '5分钟',
    tags: ['京东', '618', '满减攻略', '红包'],
    hot: true,
  },
  {
    slug: 'video-membership-comparison-2026',
    title: '2026年主流视频平台会员权益横评：腾讯视频 vs 爱奇艺 vs 优酷 vs B站',
    excerpt: '从价格、内容、画质、设备数量、联合会员等维度，全面对比四大视频平台的会员权益，帮你找到性价比最高的选择。',
    content: `<p>在流媒体竞争日益激烈的今天，选择哪个视频平台的会员成了不少用户的难题。本文将从多个维度对腾讯视频、爱奇艺、优酷和哔哩哔哩四家主流平台进行全面对比。</p>
<h4>一、价格对比</h4>
<table>
<tr><th>平台</th><th>月度价格</th><th>年度价格</th><th>联合会员</th></tr>
<tr><td>腾讯视频VIP</td><td>30元/月</td><td>258元/年</td><td>腾讯视频+京东PLUS=258元/年</td></tr>
<tr><td>爱奇艺黄金VIP</td><td>30元/月</td><td>258元/年</td><td>爱奇艺+京东PLUS=258元/年</td></tr>
<tr><td>优酷VIP</td><td>25元/月</td><td>228元/年</td><td>优酷+饿了么=228元/年</td></tr>
<tr><td>B站大会员</td><td>25元/月</td><td>233元/年</td><td>B站+QQ音乐=233元/年</td></tr>
</table>
<h4>二、内容资源</h4>
<p>腾讯视频在国产剧集和综艺方面有明显优势；爱奇艺的海外剧版权丰富；优酷以纪录片和港剧见长；B站则拥有独特的二次元内容和大量优质UP主原创视频。</p>
<h4>三、画质与设备</h4>
<p>四家平台均支持4K画质，但实际码率存在差异。腾讯视频和B站的4K码率较高，观看体验更佳。设备数量方面，腾讯视频和爱奇艺最多支持5台设备登录，优酷和B站为3台。</p>
<h4>四、联合会员推荐</h4>
<p>如果你同时需要视频和购物权益，腾讯视频+京东PLUS和爱奇艺+京东PLUS的联合会员是最具性价比的选择。如果你经常点外卖，优酷+饿了么的组合也很划算。</p>
<h4>五、总结推荐</h4>
<p>综合来看：追国产剧选腾讯视频；追海外剧选爱奇艺；看纪录片选优酷；二次元和知识类内容选B站。建议在大促期间购买年度会员，通常会有额外折扣。</p>`,
    category: 'membership',
    categoryName: '会员权益',
    imageSeq: 'art-video',
    date: '2026-07-20',
    readTime: '8分钟',
    tags: ['视频会员', '腾讯视频', '爱奇艺', '优酷', 'B站'],
    hot: true,
  },
  {
    slug: 'shenzhen-consumer-voucher-2026',
    title: '深圳发放5000万元消费券：每人最高可领800元，附领取攻略',
    excerpt: '深圳市商务局宣布新一轮消费券发放计划，总额5000万元，覆盖餐饮、零售、文旅等多个领域。本文为您详细解读领取方式和使用规则。',
    content: `<p>深圳市商务局近日宣布，为促进消费回暖，将面向全体市民发放总额5000万元的电子消费券。这是2026年深圳第二轮大规模消费券发放活动。</p>
<h4>一、消费券类型与金额</h4>
<p>本轮消费券分为四种类型：</p>
<ul>
<li>餐饮消费券：满100减30、满200减60、满500减150</li>
<li>零售消费券：满200减50、满500减120</li>
<li>文旅消费券：满100减40（适用于景区门票、酒店住宿等）</li>
<li>汽车消费券：购车直减3000-8000元</li>
</ul>
<p>每人每类消费券限领一张，合计最高可领取800元（不含汽车消费券）。</p>
<h4>二、领取方式</h4>
<p>通过"i深圳"APP或"深圳商务"微信公众号进入活动页面，点击"立即领取"即可。消费券将以电子券形式发放至个人账户，在指定商家消费时自动抵扣。</p>
<h4>三、领取时间</h4>
<p>本轮消费券分三批发放：</p>
<ul>
<li>第一批：2026年8月1日 10:00</li>
<li>第二批：2026年8月15日 10:00</li>
<li>第三批：2026年9月1日 10:00</li>
</ul>
<p>建议提前5分钟进入页面等待，前几轮的经验表明消费券通常在3分钟内被抢光。</p>
<h4>四、使用规则</h4>
<p>消费券自领取之日起15天内有效，逾期自动作废。使用时需通过微信支付或支付宝付款，系统会自动识别并抵扣相应金额。消费券不可提现、不可转让。</p>
<h4>五、适用商家</h4>
<p>全市超过5000家商户参与本次活动，包括天虹、华润万家、沃尔玛、海底捞、喜茶等知名品牌。可在"i深圳"APP中查询完整的商户名单。</p>`,
    category: 'subsidy',
    categoryName: '生活补贴',
    imageSeq: 'art-sz-voucher',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['深圳', '消费券', '政府补贴', '餐饮'],
    hot: true,
  },
  {
    slug: 'year-end-bonus-tax-planning',
    title: '年终奖个税筹划全攻略：选错方式可能多交上万元',
    excerpt: '年终奖单独计税还是合并计税？不同收入水平下的最优选择完全不同。我们通过真实案例帮你算清楚。',
    content: `<p>每年年底，年终奖的个税筹划都是职场人最关心的话题之一。选择单独计税还是合并计税，可能相差数千甚至上万元的税款。</p>
<h4>一、两种计税方式</h4>
<p><strong>单独计税：</strong>将年终奖除以12个月，按月度税率表确定适用税率和速算扣除数，单独计算税款。这种方式下，年终奖不并入当年综合所得。</p>
<p><strong>合并计税：</strong>将年终奖并入当年综合所得，按年度综合所得税率表计算税款。</p>
<h4>二、案例分析</h4>
<p>以年薪30万元（月薪2万，年终奖6万）为例：</p>
<p>单独计税：年终奖6万÷12=5000元，适用税率10%，速算扣除210元。年终奖个税=60000×10%-210=5790元。</p>
<p>合并计税：年薪30万，减去6万免征额和各项扣除约6万，应纳税所得额约18万，适用税率20%。综合个税约19080元。与单独计税（工资个税+年终奖个税≈11880+5790=17670元）相比，合并计税多交约1410元。</p>
<p>所以对于年薪30万的人来说，选择单独计税更划算。</p>
<h4>三、临界点注意</h4>
<p>年终奖存在几个"多发1元多交几千"的临界点：3.6万、14.4万、30万、42万、66万、96万。如果你的年终奖刚好在临界点附近，建议与公司协商调整。</p>
<h4>四、操作建议</h4>
<p>一般来说，年薪低于10万元的选择合并计税更划算；年薪10万-50万的选择单独计税更划算；年薪超过50万的则需要具体计算。建议使用个税计算器进行精确测算。</p>`,
    category: 'workplace',
    categoryName: '职场福利',
    imageSeq: 'art-tax',
    date: '2026-07-10',
    readTime: '7分钟',
    tags: ['年终奖', '个税', '税务筹划', '职场'],
    hot: false,
  },
  {
    slug: 'airline-mileage-redemption-guide',
    title: '航空公司里程兑换终极指南：哪个航司里程最值钱？',
    excerpt: '国航、东航、南航、海航四大航司里程价值深度对比，手把手教你用最少的里程换到最值的机票。',
    content: `<p>对于经常出行的商务人士和旅行爱好者来说，航空里程兑换是一门必修课。本文将带你深入了解四大航司里程的真实价值。</p>
<h4>一、里程获取方式</h4>
<p>除了乘坐航班累积里程外，还可以通过以下方式快速获取里程：</p>
<ul>
<li>信用卡消费积分兑换：中信、招商、浦发等银行的信用卡积分均可兑换航司里程</li>
<li>酒店住宿：入住合作酒店可获得额外里程奖励</li>
<li>租车服务：与航司合作的租车公司可累积里程</li>
<li>在线购物：通过航司的购物返利平台消费可获里程</li>
</ul>
<h4>二、里程价值排名</h4>
<p>根据我们的测算，四大航司里程的实际使用价值如下：</p>
<ul>
<li><strong>海航金鹏俱乐部：</strong>每万里程价值约800-1200元（最高）</li>
<li><strong>国航凤凰知音：</strong>每万里程价值约700-1000元</li>
<li><strong>南航明珠俱乐部：</strong>每万里程价值约650-950元</li>
<li><strong>东航东方万里行：</strong>每万里程价值约600-900元</li>
</ul>
<h4>三、兑换技巧</h4>
<p>1. 淡季兑换：航司在淡季会调低所需里程数，同样的目的地可能节省30%-50%的里程。</p>
<p>2. 关注促销：双11、618等大促期间，部分航线会推出里程5折兑换活动。</p>
<p>3. 灵活日期：前后调整1-2天往往能找到更低里程的航班。</p>
<h4>四、注意事项</h4>
<p>里程通常有3年的有效期，过期自动作废。建议定期查看账户，及时使用即将过期的里程。部分航司支持里程延期，但需要满足一定条件。</p>`,
    category: 'travel',
    categoryName: '出行旅游',
    imageSeq: 'art-mileage',
    date: '2026-06-28',
    readTime: '6分钟',
    tags: ['航空里程', '机票兑换', '旅游福利', '海航'],
    hot: false,
  },
  {
    slug: 'online-course-certificate-subsidy',
    title: '在线学习也能领补贴：Coursera和Udemy课程费用减免攻略',
    excerpt: '多个平台提供在线课程补贴，部分课程可全额报销。本文整理了目前可申请的教育补贴项目和申请条件。',
    content: `<p>随着终身学习理念的普及，越来越多的平台和政府机构开始提供在线学习补贴。如果你正在考虑提升技能，不妨先看看这些可以帮你省钱甚至免费的渠道。</p>
<h4>一、平台内优惠</h4>
<p>Coursera提供"经济援助计划"：填写一份简短的申请表，说明你的经济状况和学习动机，就有机会获得课程费用的全额减免。审批通过率约为60%，一般2周内出结果。</p>
<p>Udemy经常推出全场9.9美元的特价活动，建议先收藏心仪课程，等打折时再购买。另外关注Udemy的官方社交媒体账号，可以第一时间获取优惠码。</p>
<h4>二、政府补贴项目</h4>
<p>多个城市推出了职业技能提升补贴政策。以北京为例，参加指定平台的在线培训课程并通过考核后，可申请1000-3000元不等的培训补贴。具体可在当地人社局官网查询。</p>
<h4>三、企业报销</h4>
<p>许多大型企业设有员工学习发展基金，每年可报销一定金额的培训费用。建议查看公司内部的学习发展政策，或直接咨询HR部门。部分企业还支持学历提升的部分费用报销。</p>
<h4>四、免费资源推荐</h4>
<p>如果预算有限，以下平台提供大量免费优质课程：</p>
<ul>
<li>中国大学MOOC：国内顶尖高校的免费课程</li>
<li>学堂在线：清华、北大等名校课程免费学</li>
<li>国家高等教育智慧教育平台：国家级免费学习平台</li>
</ul>
<h4>五、申请技巧</h4>
<p>申请补贴时，注意保留完整的发票、支付凭证和课程完成证书。部分补贴项目要求课程完成率达到80%以上才能申请。</p>`,
    category: 'education',
    categoryName: '教育学习',
    imageSeq: 'art-course',
    date: '2026-07-05',
    readTime: '5分钟',
    tags: ['在线课程', '教育补贴', 'Coursera', 'Udemy'],
    hot: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.hot);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};